import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";

const IconHotelOnly = ({ size, ...props }) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...(size !== undefined && { width: size, height: size })}
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.95006 11V21H10.2501V11C10.2501 9.48122 11.4813 8.25 13.0001 8.25H19.0001C20.5189 8.25 21.7501 9.48122 21.7501 11V21H22.0003C22.5526 21 23.0003 21.4477 23.0003 22C23.0003 22.5523 22.5526 23 22.0003 23H2.00024C1.44796 23 1.00024 22.5523 1.00024 22C1.00024 21.4477 1.44796 21 2.00024 21H2.25006V14.75H5.26718C5.68139 14.75 6.01718 14.4142 6.01718 14C6.01718 13.5858 5.68139 13.25 5.26718 13.25H2.25006V10.75H5.26718C5.68139 10.75 6.01718 10.4142 6.01718 10C6.01718 9.58579 5.68139 9.25 5.26718 9.25H2.25006V6.75H5.26718C5.68139 6.75 6.01718 6.41421 6.01718 6C6.01718 5.58579 5.68139 5.25 5.26718 5.25H2.25006V4C2.25006 2.48122 3.48128 1.25 5.00006 1.25H13.0001C14.5189 1.25 15.7501 2.48122 15.7501 4V6.95H13.0001C10.7633 6.95 8.95006 8.76325 8.95006 11ZM16.7501 19V21H15.2501V19C15.2501 18.5858 15.5859 18.25 16.0001 18.25C16.4143 18.25 16.7501 18.5858 16.7501 19ZM15.0001 12.25C14.5859 12.25 14.2501 12.5858 14.2501 13C14.2501 13.4142 14.5859 13.75 15.0001 13.75H17.0001C17.4143 13.75 17.7501 13.4142 17.7501 13C17.7501 12.5858 17.4143 12.25 17.0001 12.25H15.0001ZM15.0001 15.25C14.5859 15.25 14.2501 15.5858 14.2501 16C14.2501 16.4142 14.5859 16.75 15.0001 16.75H17.0001C17.4143 16.75 17.7501 16.4142 17.7501 16C17.7501 15.5858 17.4143 15.25 17.0001 15.25H15.0001Z"
			fill="currentColor"
		/>
	</svg>
);

IconHotelOnly.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default IconHotelOnly;
